import React, { Component } from 'react';
import { Table, Alert } from "reactstrap";
import ItemConversion from './ItemConversion.js';
import { _getListConversions, _conversion } from '../../../../../services/apis/AdminAffiliate.js';
import Pages from '../pagination/Pages.js';
import {changeQuerySearch, parseSearchQuery} from "../../../../../helpers/routes/RouterHelper"

const getInitPage = () =>{
    const parsed = parseSearchQuery();
    return !!parsed.page ? parseInt(parsed.page, 10) : 1;
}

class ConversionPage extends Component {
    state = {
        listConversions: [],
        error: '',
        total: 0,
        pages: {
            page:  getInitPage(),
            limit: 10,
            maxPage: 1
        }
    }

    componentDidMount() {
        this.getListConversions();
    }

    componentDidUpdate(preProps, preState) {
        const { page } = this.state.pages;
        if (preState.pages.page !== page) {
            this.getListConversions();
        }
    }

    getListConversions = () => {
        const {pages} = this.state;

        _getListConversions(pages)
            .then((result) => {
                if (result.success) {
                    this.setState(prevState =>({
                        listConversions: result.data.docs,
                        error: '',
                        total: result.data.total,
                        pages: {
                            ...prevState.pages,
                            page: result.data.page,
                            maxPage: result.data.pages,

                        }

                    }));
                } else {
                    this.setState({
                        error: result.message
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    error: error.message
                });
            });
    }

    handleGoToPage = (index) => {
        const { limit, maxPage } = this.state.pages;
        changeQuerySearch({page: index});
        this.setState({
            pages: {
                page: index,
                limit,
                maxPage
            }
        })
    }

    handleClick = (request, status) => () => {
        const { listConversions } = this.state;
        const id = request['_id'];

        _conversion(id, status)
            .then((result) => {
                if (result.success) {
                    const newRequest = listConversions.map(ItemRequest => {
                        if (ItemRequest['_id'] === request['_id']) {
                            request.status = status;
                            return request;
                        }
                        return ItemRequest;
                    });

                    this.setState({
                        listConversions: newRequest,
                        error: ''
                    })
                } else {
                    this.setState({
                        error: result.message
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    error: error.message
                });
            });
    }

    render() {
        const { listConversions, error, pages ,total} = this.state;

        return (
            <div className="ConversionPage">
                {
                    !!error ? <Alert color="danger">{error}</Alert> : ''
                }
                <h2>Convertions({total})</h2>
                <Table>
                    <thead>
                        <tr>
                            <th>BILL</th>
                            <th>PAYER</th>
                            <th>BROKER</th>
                            <th>STATUS</th>
                            <th>EARNED</th>
                            <th>CREATED</th>
                        </tr>
                    </thead>
                    {
                        listConversions.map((conversion, index) => {
                            return (
                                <ItemConversion
                                    key={index}
                                    conversion={conversion}
                                    handleClick={this.handleClick}
                                />
                            );
                        })
                    }
                </Table>

                <Pages
                    pages={pages}
                    handleGoToPage={this.handleGoToPage}
                />
            </div>
        );
    }
}

export default ConversionPage;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/affiliate/conversion/ConversionPage.js